<template>
  <div :key="componentKey">
    <!-- Generamos el AppBar con las distintas acciones -->
    <v-app-bar v-if="show_app_bar" color="primary" dense dark style="border-radius: 5px">
      <!-- Crear una nueva categoria -->
      <v-btn v-if="show_btn_nueva_venta" text @click="open_dialog_venta">
        <v-icon>mdi-currency-usd</v-icon>
        <span class="appbar_button">
          {{ $t("Nueva venta") }}
        </span>
      </v-btn>

      <v-btn text @click="open_dialog_enviar_sms" v-if="show_newsletter">
        <v-icon>mdi-message-text-outline</v-icon>
        <span class="appbar_button">{{ $t("Enviar un SMS") }}</span>
      </v-btn>

      <v-btn text @click="open_dialog_enviar_email" v-if="show_newsletter">
        <v-icon>mdi-email-edit-outline</v-icon>
        <span class="appbar_button">{{ $t("Enviar un email") }}</span>
      </v-btn>

      <v-menu bottom offset-y>
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on">
            <v-icon>mdi-dots-horizontal
            </v-icon>
            <span class="appbar_button">{{ $t("Otras acciones") }}</span>
            <v-icon
                small
            >mdi-chevron-down
            </v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item class="pointer" @click="open_dialog_enviar_sms_programado" v-if="show_newsletter">
            <v-list-item-title>
              <v-icon>mdi-message-text-clock</v-icon>
              {{ $t("Programar un SMS") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="pointer" @click="open_dialog_unir">
            <v-list-item-title>
              <v-icon>mdi-call-merge</v-icon>
              {{ $t("Unir clientes") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="pointer" @click="imprimir_ficha_cliente">
            <v-list-item-title>
              <v-icon>mdi-printer</v-icon>
              {{ $t("Imprimir ficha") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="pointer" @click="imprimir_notas_cliente">
            <v-list-item-title>
              <v-icon>mdi-printer</v-icon>
              {{ $t("Imprimir notas") }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-spacer />
        <v-btn icon href="https://www.youtube.com/playlist?list=PL2a9kD1kP16e4UCE3ZL4HARaUmQyPvpRG">
            <v-icon>mdi-video</v-icon>
        </v-btn>
    </v-app-bar>

    <v-container fluid  v-if="cliente">

      <!-- Ficha del cliente -->
      <v-row class="pl-2 pr-2">
        <v-col sm='12' md="2" class="mb-1">

          <v-img
              @click="open_dialog_foto"
              style="cursor: pointer; border-radius: 12px; margin-left: auto; margin-right: auto"
              :src="cliente.foto_url_absolute_path"
              width="245"
              height="245"
              contain
          />

          <h4 class="mt-2 text-ellipsis text-center">{{ cliente.nombre_completo }}</h4>
          <ul class="user_data">
            <li v-if="cliente.direccion && show_direccion_cliente" class="text-ellipsis">
              <v-icon>mdi-map-marker</v-icon>
              {{ cliente.direccion }}
            </li>
            <li v-if="cliente.movil && show_movil_cliente" class="text-ellipsis">
              <v-icon>mdi-cellphone</v-icon>
              <span v-if="cliente.prefijo_tel">+</span>{{ cliente.prefijo_tel }} {{ cliente.movil }}
            </li>
            <li v-if="cliente.email && show_email_cliente" class="text-ellipsis text-lowercase">
              <v-icon>mdi-at</v-icon>
              {{ cliente.email }}
            </li>
            <li><v-switch v-model="cliente.is_citas_online" :label="$t('Citas online')" @change="save"/></li>
            <li v-if="!cliente.is_suscrito_newsletter" class="text-ellipsis">No está suscrito a envíos por email</li>
          </ul>
          <v-btn small block color="primary" class="mt-3" @click="open_dialog_cliente">
            <v-icon dark>
              mdi-account-edit
            </v-icon>
            {{ $t("Editar") }}
          </v-btn>

          <v-btn v-if="is_user_online" small block color="primary" class="mt-3" @click="open_dialog_password">
            <v-icon dark>
              mdi-lock-reset
            </v-icon>
            {{ $t("Cambiar contraseña") }}
          </v-btn>

          <hr class="mt-3 mb-3">

          <div>
           <span class="error--text font-weight-bold">
             <v-icon color="error">mdi-badge-account-alert-outline</v-icon>
             {{ $t("Información clínica") }}
             <v-btn dark icon class="green" x-small @click="open_dialog_notas(1)">
               <v-icon>mdi-pencil-outline</v-icon>
             </v-btn>
           </span>
            <p v-if="cliente.informacion_clinica"
               class="small-text preline font-italic">{{ cliente.informacion_clinica }}</p>
          </div>

          <div class="mt-4">
            <span class="font-weight-bold">
             <v-icon>mdi-notebook</v-icon>
             {{ $t("Notas") }}
              <v-btn dark icon class="green" x-small @click="open_dialog_notas(2)">
               <v-icon>mdi-pencil-outline</v-icon>
             </v-btn>
           </span>
            <p v-if="cliente.notas" class="small-text preline font-italic">{{ cliente.notas }}</p>
          </div>
        </v-col>
        <v-col sm='12' md="10">
          <v-tabs class="elevation-2" v-if="active_tab" v-model="active_tab" grow
                  show-arrows prev-icon="mdi-arrow-left-circle" next-icon="mdi-arrow-right-circle">

            <!-- Apartado de tabs -->
            <!-- Deudas -->
            <v-tab class="deudas" href="#tab-deudas">
              <span class="tab_title error--text">{{ $t('Deudas') }}</span>
            </v-tab>

            <!-- Citas -->
            <v-tab v-if="show_citas_cliente" href="#tab-citas">
              <span class="tab_title">{{ $t("Citas") }}</span>
            </v-tab>

            <!-- Ventas -->
            <v-tab v-if="show_ventas_cliente" href="#tab-ventas">
              <span class="tab_title">{{ $t("Ventas") }}</span>
            </v-tab>

            <!-- Bonos -->
            <v-tab href="#tab-bonos">
              <span class="tab_title">{{ $t("Bonos") }}</span>
            </v-tab>

            <!-- Tarjetas Fidelidad -->
            <v-tab href="#tab-tarjetas-fidelidad">
              <span class="tab_title">{{ $t("Tarjetas Fidelidad") }}</span>
            </v-tab>

            <!-- Presupuestos -->
            <v-tab href="#tab-presupuestos">
              <span class="tab_title">{{ $t("Presupuestos") }}</span>
            </v-tab>

            <!-- Cuotas -->
            <v-tab href="#tab-suscripciones">
              <span class="tab_title">{{ $t("Suscripciones") }}</span>
            </v-tab>

            <!-- Agenda -->
            <v-tab v-if="show_tab_agenda" href="#tab-agenda">
              <span class="tab_title">{{ $t("Agenda") }}</span>
            </v-tab>

            <!-- Documentos -->
            <v-tab href="#tab-documentos">
              <span class="tab_title">{{ $t("Documentos") }}</span>
            </v-tab>

            <!-- Encuestas -->
            <v-tab href="#tab-encuestas">
              <span class="tab_title">{{ $t("Encuestas") }}</span>
            </v-tab>

            <!-- Cuestionarios -->
            <v-tab href="#tab-cuestionarios">
              <span class="tab_title">{{ $t("Cuestionarios") }}</span>
            </v-tab>

            <!-- Consentimientos -->
            <v-tab href="#tab-consentimientos">
              <span class="tab_title">{{ $t("Consentimientos") }}</span>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="active_tab" class="elevation-2" touchless>
            <v-tab-item value="tab-deudas" class="pa-4 grey lighten-5">
              <DeudasCliente v-if="cliente && active_tab === 'tab-deudas'" :cliente="cliente"/>
            </v-tab-item>

            <v-tab-item v-if="show_citas_cliente" value="tab-citas" class="pa-4 grey lighten-5">
              <CitasCliente v-if="id_cliente && active_tab==='tab-citas'" ref="citas_cliente"
                            @on_cita_clicked="open_dialog_cita"
                            :id_cliente="id_cliente"/>
            </v-tab-item>

            <v-tab-item v-if="show_ventas_cliente" value="tab-ventas" class="pa-4 grey lighten-5">
              <VentasCliente v-if="id_cliente && active_tab==='tab-ventas'" ref="ventas_cliente" :cliente="cliente"
              />
            </v-tab-item>

            <!-- Ventas online -->
            <!--            <v-tab href="#tab-ventas-online">-->
            <!--              <span class="tab_title">{{ $t("Ventas online") }}</span>-->
            <!--            </v-tab>-->
            <!--            &lt;!&ndash; Contenido del tab &ndash;&gt;-->
            <!--            <v-tab-item value="tab-ventas-online" class="pa-4 grey lighten-5">-->
            <!--              <VentasClienteOnline v-if="id_cliente" ref="ventas_cliente_online" :id_cliente="id_cliente"/>-->
            <!--            </v-tab-item>-->

            <v-tab-item value="tab-bonos" class="pa-4 grey lighten-5">
              <TablaBonosVendidos
                  ref="tabla_bonos_vendidos"
                  v-if="id_cliente && active_tab==='tab-bonos'"
                  :selected_filters="{'cliente': id_cliente}"
                  @on_click_ver_sesiones="open_dialog_sesiones"
                  @on_click_edit="open_dialog_editar_bono_vendido"
                  @on_click_deactivate="deactivate_bono_vendido"
                  @on_click_delete="delete_bono_vendido"
              />
            </v-tab-item>

            <v-tab-item value="tab-tarjetas-fidelidad" class="pa-4 grey lighten-5">
              <TablaTarjetasFidelidadVendidas
                  ref="tabla_tarjetas_fidelidad_vendidas"
                  v-if="id_cliente && active_tab==='tab-tarjetas-fidelidad'"
                  :selected_filters="{'cliente__in': id_cliente}"
                  show_actions
                  @on_click_traspasar_saldo="open_dialog_traspasar_saldo_tarjetas_fidelidad"
                  @on_click_ver_movimientos="open_dialog_movimientos_tarjeta_fidelidad_vendida"
                  @on_click_imprimir="imprimir_tarjeta_fidelidad_vendida"
              />
            </v-tab-item>

            <v-tab-item value="tab-presupuestos" class="pa-4 grey lighten-5">
              <v-row>
                <v-col cols="12" class="text-end">
                  <v-btn small class="ma-2" color="primary" @click="open_dialog_presupuesto">
                    {{ $t("Nuevo presupuesto") }}
                  </v-btn>
                </v-col>
              </v-row>
              <TablaPresupuestos
                  v-if="id_cliente"
                  :selected_filters="{'cliente': id_cliente}"
                  :email_cliente="cliente.email"
                  @on_click_imprimir_presupuesto="imprimir_presupuesto"
                  @on_click_imprimir_ticket_presupuesto="imprimir_ticket_presupuesto"
                  @on_click_enviar_email_presupuesto="enviar_email_presupuesto"
                  @on_click_ver_presupuesto="open_dialog_presupuesto"
                  @on_click_eliminar_presupuesto="eliminar_presupuesto"
                  @on_click_generar_venta="generar_venta_presupuesto"
                  ref="tabla_presupuestos"
              />
            </v-tab-item>

            <v-tab-item value="tab-suscripciones" class="pa-4 grey lighten-5">
              <TablaSuscripcionesContratadas
                  ref="tabla_suscripciones_contratadas"
                  v-if="cliente && active_tab==='tab-suscripciones'"
                  :selected_filters="{'is_active': true, 'cliente': cliente.id}"
              />
            </v-tab-item>

            <v-tab-item v-if="show_tab_agenda" value="tab-agenda" class="pa-4 grey lighten-5">
              <AgendaScheduler
                  ref="agenda_scheduler"
                  :cliente="cliente"
                  @on_click_cobrar_cita="venta_from_cita"
              />
            </v-tab-item>

            <v-tab-item value="tab-documentos" class="pa-4 grey lighten-5">
              <v-row class="ma-0">
                <v-col cols="12" class="text-end">
                  <v-btn small @click="open_dialog_documento" color="primary">
                    {{ $t("Adjuntar documento") }}
                  </v-btn>
                </v-col>
              </v-row>
              <TablaDocumentos
                  v-if="cliente && active_tab==='tab-documentos'"
                  :selected_filters="{'cliente': id_cliente}"
                  ref="tabla_documentos"
              />
            </v-tab-item>

            <v-tab-item value="tab-encuestas" class="pa-4 grey lighten-5">
              <TablaEncuestas
                  v-if="cliente && active_tab==='tab-encuestas'"
                  :selected_filters="{'cliente': id_cliente}"
              />
            </v-tab-item>

            <v-tab-item value="tab-cuestionarios" class="pa-4 grey lighten-5">
              <Cuestionarios
                  v-if="cliente && active_tab==='tab-cuestionarios'"
                  :cliente="cliente"
              />
            </v-tab-item>

            <!-- Contenido del tab -->
            <v-tab-item value="tab-consentimientos" class="pa-4 grey lighten-5">
              <TabConsentimientos
                  v-if="cliente && active_tab==='tab-consentimientos'"
                  :cliente="cliente"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>

    <!-- Dialogo de cliente con el formulario -->
    <FormCliente
        ref="form_cliente"
        v-if="dialog_cliente"
        v-model="dialog_cliente"
        :item="cliente"
        @on_save="update_data_cliente"/>

    <!-- Dialogo de la cita con el formulario -->
    <FormCita v-if="dialog_cita"
              v-model="dialog_cita"
              :item="current_cita"
              @on_save="on_save_cita"
              @on_click_cobrar="venta_from_cita"
    />
    <FormSMS v-if="dialog_enviar_sms"
             v-model="dialog_enviar_sms"
             @on_send="dialog_enviar_sms = false"
             :item="cliente"
    />
    <FormEmail v-if="dialog_enviar_email"
               v-model="dialog_enviar_email"
               @on_send="dialog_enviar_email = false"
               :item="cliente"
    />
    <FormSMSProgramado v-if="dialog_enviar_sms_programado"
                       v-model="dialog_enviar_sms_programado"
                       @on_send="dialog_enviar_sms_programado = false"
                       :item="cliente"
    />
    <FormUnir v-if="dialog_unir"
              v-model="dialog_unir"
              :item="cliente"
              @reload="reload"
    />
    <FormVenta
        ref="form_venta"
        v-if="dialog_venta"
        v-model="dialog_venta"
        :cliente="cliente"
        :item="current_venta"
        @on_save="on_save_venta"
    />

    <FormDocumento
        v-model="dialog_documento"
        v-if="dialog_documento"
        :cliente="cliente.id"
        @on_save="get_documentos"
    />

    <DialogSesiones
        v-if="dialog_sesiones"
        v-model="dialog_sesiones"
        :item="current_bono_vendido"
        @on_delete_sesion="on_save_bono_vendido"
    />

    <FormEditarBonoVendido
        v-if="dialog_editar_bono_vendido"
        v-model="dialog_editar_bono_vendido"
        :item="current_bono_vendido"
        @on_save="on_save_bono_vendido"
    />

    <DialogFotoCliente
        v-model="dialog_foto_cliente"
        v-if="dialog_foto_cliente"
        :cliente="cliente"
        @save="on_save_image"
    />

    <DialogTraspasarSaldoTarjetaFidelidad
        v-model="dialog_traspasar_saldo"
        v-if="dialog_traspasar_saldo"
        :lista_tarjetas_fidelidad="lista_tarjetas_fidelidad"
        :tarjeta_fidelidad_seleccionada="tarjeta_fidelidad_seleccionada"
        ref="dialog_traspasar_saldo_tarjetas_fidelidad"
        @on_traspasar_saldo="on_traspasar_saldo"
    />

    <DialogMovimientosTarjetaFidelidad
        ref="dialog_movimientos_tarjeta_fidelidad"
    />

    <FormPresupuesto
        v-if="dialog_presupuesto"
        v-model="dialog_presupuesto"
        :item="current_presupuesto"
        :cliente="cliente"
        @on_save="on_save_presupuesto"
        @on_save_print="on_save_print_presupuesto"
        @on_save_print_ticket="on_save_print_ticket_presupuesto"
    />

    <FormPasswordClienteOnline
        v-if="dialog_password"
        v-model="dialog_password"
        :item="cliente"
        @on_password_changed="on_password_changed"
    />

<!--    Así para evitar problemas de reactividad al editar props-->
    <Dialog v-model="dialog_notas" v-if="!!dialog_notas"
            :title="dialog_notas===1? $t('Información clínica'):$t('Notas')">
      <template v-slot:content>
        <v-textarea
            v-model="texto_editar"
            outlined
            rows="10"
        />
      </template>
      <template v-slot:right-action>
        <v-btn small @click="edit_texto(dialog_notas)" class="primary ml-2">{{ $t("Guardar") }}</v-btn>
      </template>
    </Dialog>
  </div>
</template>


<script>

export default {
  name: 'FichaCliente',
  data() {
    return {
      componentKey: 1,
      active_tab: "tab-citas",
      cliente: null,
      current_cita: null,
      current_bono_vendido: null,
      dialog_cliente: false,
      dialog_cita: false,
      dialog_enviar_sms: false,
      dialog_enviar_email: false,
      dialog_enviar_sms_programado: false,
      dialog_unir: false,
      dialog_venta: false,
      dialog_sesiones: false,
      dialog_editar_bono_vendido: false,
      dialog_documento: false,
      dialog_presupuesto: false,
      dialog_foto_cliente: false,
      dialog_traspasar_saldo: false,
      dialog_notas: 0,
      dialog_password: false,
      texto_editar: null,
      lista_tarjetas_fidelidad: null,
      tarjeta_fidelidad_seleccionada: null,
      current_presupuesto : null,
      current_venta: null,
      show_newsletter: false
    }
  },
  methods: {
    /**
     * Carga el cliente actual
     * @param id_cliente
     * @returns {Promise<void>}
     */
    async get_cliente(id_cliente) {
      try {
        this.cliente = await this.$store.dispatch('cliente/get_cliente', id_cliente)
      } catch (err) {
        this.$snotify.error(
          this.$t("Ha ocurrido un error"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    /**
     * Muestra el dialog de la cita clicada
     * @param cita
     */
    open_dialog_cita(cita) {
      this.current_cita = cita
      this.dialog_cita = true
    },

    /**
     * Muestra los dialogs de cada botón
     */
    open_dialog_cliente() {
      this.dialog_cliente = true
    },

    open_dialog_enviar_sms() {
      this.dialog_enviar_sms = true
    },

    open_dialog_enviar_email() {
      this.dialog_enviar_email = true
    },

    open_dialog_enviar_sms_programado() {
      this.dialog_enviar_sms_programado = true
    },

    open_dialog_unir() {
      this.dialog_unir = true
    },

    open_dialog_venta(venta= {}){
      this.current_venta = venta
      this.dialog_venta = true
    },

    open_dialog_documento(){
      this.dialog_documento = true
    },

    open_dialog_password(){
      this.dialog_password = true
    },

    get_documentos(){
      this.$refs.tabla_documentos.get_documentos()
    },

    open_dialog_foto(){
      this.dialog_foto_cliente = true
    },

    async open_dialog_sesiones(bono_vendido) {
      this.current_bono_vendido = bono_vendido
      this.dialog_sesiones = true
    },

    async open_dialog_editar_bono_vendido(bono_vendido) {
      this.current_bono_vendido = bono_vendido
      this.dialog_editar_bono_vendido = true
    },

    on_password_changed(){
      this.dialog_password = false
      this.get_cliente(this.id_cliente)
    },

    open_dialog_notas(tipo) {
      if (tipo === 1) {
        this.texto_editar = this.cliente.informacion_clinica
      } else if (tipo === 2) {
        this.texto_editar = this.cliente.notas
      }

      this.dialog_notas = tipo
    },

    async edit_texto(dialog_notas) {
      if (dialog_notas === 1) {
        this.cliente.informacion_clinica = this.texto_editar
      } else if (dialog_notas === 2) {
        this.cliente.notas = this.texto_editar
      }

      await this.save()
      this.dialog_notas = 0
    },

    async save(){
      try {
        this.cliente = await this.$store.dispatch('cliente/save', this.cliente)
        this.$snotify.success(
            this.$t("Acción realizada con éxito"),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
        this.$emit('on_save', this.cliente)
      } catch (err) {
        this.$snotify.error(
            this.$t("Ha ocurrido un error"),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    /**
     * Cierra el diálogo de venta una vez
     * guardada
     */
    on_save_venta() {
      this.dialog_venta = false

      switch (this.active_tab){
        case 'tab-citas':
          this.dialog_cita = false
          this.$refs.citas_cliente.get_citas_cliente(this.id_cliente)
          break

        case 'tab-ventas':
          this.$refs.ventas_cliente.get_puntos()
          this.get_cliente(this.id_cliente)
          this.$refs.ventas_cliente.get_ventas(this.id_cliente)
          break

        case 'tab-bonos':
          this.$refs.tabla_bonos_vendidos.get_bonos_vendidos()
          break

        case 'tab-presupuestos':
          this.$refs.tabla_presupuestos.get_presupuestos()
          break

        case 'tab-tarjetas-fidelidad':
          this.$refs.tabla_tarjetas_fidelidad_vendidas.get_tarjetas_fidelidad_vendidas()
          break

        case 'tab-agenda':
          this.$refs.agenda_scheduler.dialog_cita = false
          this.$refs.agenda_scheduler.get_citas()
          break
      }
    },

    on_traspasar_saldo() {
      this.$refs.tabla_tarjetas_fidelidad_vendidas.get_tarjetas_fidelidad_vendidas()
    },

    open_dialog_movimientos_tarjeta_fidelidad_vendida(tarjeta_fidelidad_vendida) {
      this.$refs.dialog_movimientos_tarjeta_fidelidad.open_dialog(tarjeta_fidelidad_vendida)
    },

    imprimir_tarjeta_fidelidad_vendida(tarjeta_fidelidad_vendida) {
      let routeData = this.$router.resolve({
        name: 'print_tarjeta_fidelidad_vendida',
        params: {id: tarjeta_fidelidad_vendida.id}
      });
      window.open(routeData.href, '_blank');
    },

    /**
     * Actualiza la data del cliente después de un guardado
     * @param cliente
     */
    async update_data_cliente(cliente) {
      await this.get_cliente(cliente.id)
      this.dialog_cliente = false
    },

    /**
     * Recarga las citas después de un guardado
     */
    on_save_cita() {
      this.dialog_cita = false
      this.$refs.citas_cliente.get_citas_cliente(this.id_cliente)
    },

    /**
     * Cierra el dialog y recarga los bonos vendidos
     */
    on_save_bono_vendido() {
      this.dialog_editar_bono_vendido = false
      this.$refs.tabla_bonos_vendidos.get_bonos_vendidos()
    },

    /**
     * Desactivar un bono vendido
     */
    async deactivate_bono_vendido(bono_vendido) {
      try {
        const resp = await this.$confirm(this.$t('¿Desactivar definitivamente?').toString())
        if (resp) {
          try {
            await this.$store.dispatch('bono/deactivate_bono_vendido', bono_vendido.id)
            this.$snotify.success(
                this.$t("La acción se ha realizado correctamente"),
                this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
            )
            this.$refs.tabla_bonos_vendidos.get_bonos_vendidos()
          } catch (err) {
          }
        }
      } catch (err) {
      }
    },

    /**
     * Elimina un bono vendido
     */
    async delete_bono_vendido(bono_vendido) {
      try {
        const resp = await this.$confirm(this.$t('¿Eliminar definitivamente?').toString())
        if (resp) {
          try {
            await this.$store.dispatch('bono/delete_bono_vendido', bono_vendido)
            this.$snotify.success(
              this.$t("La acción se ha realizado correctamente"),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
            )
            this.$refs.tabla_bonos_vendidos.get_bonos_vendidos()
          } catch (err) {
          }
        }
      } catch (err) {
      }
    },

    open_dialog_traspasar_saldo_tarjetas_fidelidad(payload) {
      this.tarjeta_fidelidad_seleccionada = payload['tarjeta_fidelidad_seleccionada']
      this.lista_tarjetas_fidelidad = payload['tarjetas_fidelidad']
      this.dialog_traspasar_saldo = true
    },

    imprimir_ficha_cliente() {
      window.open(this.$router.resolve({name: 'print_ficha_cliente', params: {id: this.cliente.id}}).href, '_blank')
    },

    imprimir_notas_cliente() {
      window.open(this.$router.resolve({name: 'print_notas_cliente', params: {id: this.cliente.id}}).href, '_blank')
    },

    async get_presupuestos() {
      await this.$refs.tabla_presupuestos.get_presupuestos()
    },

    async imprimir_presupuesto(presupuesto_id) {
      await this.$store.dispatch('presupuestos/imprimir_presupuesto', presupuesto_id)
    },

    imprimir_ticket_presupuesto(presupuesto_id) {
      window.open(this.$router.resolve({name: 'print_ticket_presupuesto', params: {id: presupuesto_id}}).href, '_blank')
    },

    async enviar_email_presupuesto(presupuesto_id) {
      if (!this.cliente.email){
        return this.$snotify.warning(
          this.$t("El cliente no tiene un email asociado"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
      try {
        await this.$store.dispatch('presupuestos/enviar_email_presupuesto', presupuesto_id)
        return this.$snotify.success(
          this.$t("El email se ha enviado correctamente"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      } catch (e) {
        this.$snotify.error(
          this.$t("No se ha podido enviar el email"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    open_dialog_presupuesto(presupuesto) {
      this.current_presupuesto = presupuesto
      this.dialog_presupuesto = true
    },

    reload() {
      this.componentKey=!this.componentKey
    },

    async on_save_image() {
      this.dialog_foto_cliente = false
      await this.get_cliente(this.id_cliente)
    },

    async eliminar_presupuesto(id) {
      try {
        await this.$store.dispatch('presupuestos/delete', id)
        this.$snotify.success(
          this.$t("La acción se ha realizado correctamente"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      } catch (e) {
        this.$snotify.error(
          this.$t("No se ha podido eliminar el presupuesto"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
      await this.get_presupuestos()
    },

    async on_save_presupuesto() {
      this.dialog_presupuesto = false
      await this.get_presupuestos()
    },

    async on_save_print_presupuesto (presupuesto) {
      this.dialog_presupuesto = false
      await this.imprimir_presupuesto(presupuesto.id)
      await this.get_presupuestos()
    },

    async on_save_print_ticket_presupuesto (presupuesto) {
      this.dialog_presupuesto = false
      await this.imprimir_ticket_presupuesto(presupuesto.id)
      await this.get_presupuestos()
    },

    generar_venta_presupuesto(presupuesto) {
      let assigned
      if (presupuesto.created_by) {
        assigned = presupuesto.created_by.value
      } else {
        assigned = this.$store.state.auth.user.id
      }
      this.current_venta = {
        presupuesto: presupuesto.id,
        assigned_to: assigned,
        base_imponible: presupuesto.base_imponible,
        cliente: presupuesto.cliente,
        total: presupuesto.total,
        valor_descuento: presupuesto.valor_descuento,
        tipo_descuento: presupuesto.tipo_descuento,
        lineas_venta: [...presupuesto.lineas_presupuesto]
      }

      this.current_venta.lineas_venta.forEach((current_linea)=>{
        delete current_linea.id
      })

      this.dialog_venta = true
    },

    async venta_from_cita(cita){
      let citas_ids = []
      if(cita instanceof Array){
        cita.map((current_cita)=>{
          citas_ids.push(current_cita.id)
        })
      }else{
        citas_ids = [cita.id]
      }
      const venta = await this.$store.dispatch('venta/get_venta_from_citas', citas_ids)
      venta.cita = citas_ids[0]
      venta.citas = citas_ids
      this.open_dialog_venta(venta)
    },

  },
  mounted() {
    this.get_cliente(this.id_cliente)
    this.show_newsletter = this.$store.state.auth.user.tipo_empleado === 'admin'
  },
  props: {
    id_cliente: {
      required: true
    },
    show_app_bar: {
      type: Boolean,
      default: true
    },
    show_tab_agenda: {
      type: Boolean,
      default: true
    },
  },

  watch: {
    'id_cliente': {
      async handler(){
        await this.get_cliente(this.id_cliente)
        this.$data.active_tab = 'tab-bonos'
        this.$refs.tabla_bonos_vendidos.get_bonos_vendidos()
      }
    }
  },

  computed: {
    show_email_cliente(){
      if (this.$store.state.auth.user.tipo_empleado === 'admin') {
        return true
      } else {
        if (this.$store.getters['auth/has_permission']("ver_email_cliente")) {
          return true
        }
      }
      return false
    },
    show_movil_cliente(){
      if (this.$store.state.auth.user.tipo_empleado === 'admin') {
        return true
      } else {
        if (this.$store.getters['auth/has_permission']("ver_movil_cliente")) {
          return true
        }
      }
      return false
    },
    show_direccion_cliente(){
      if (this.$store.state.auth.user.tipo_empleado === 'admin') {
        return true
      } else {
        if (this.$store.getters['auth/has_permission']("ver_direccion_cliente")) {
          return true
        }
      }
      return false
    },
    show_ventas_cliente(){
      if (this.$store.state.auth.user.tipo_empleado === 'admin') {
        return true
      } else {
        if (this.$store.getters['auth/has_permission']("ver_ventas_cliente")) {
          return true
        }
      }
      return false
    },
    show_citas_cliente(){
      if (this.$store.state.auth.user.tipo_empleado === 'admin') {
        return true
      } else {
        if (this.$store.getters['auth/has_permission']("ver_citas_cliente")) {
          return true
        }
      }
      return false
    },
    show_btn_nueva_venta(){
      if (this.$store.state.auth.user.tipo_empleado === 'admin') {
        return true
      } else {
        if (this.$store.getters['auth/has_permission']("realizar_ventas")) {
          return true
        }
      }
      return false
    },
    is_user_online(){
      return this.cliente.user_online
    },
  },

  components: {
    FormPasswordClienteOnline: () => import('@/views/Clientes/Components/FormPasswordClienteOnline'),
    FormCliente: () => import('@/views/Clientes/Components/FormCliente'),
    AgendaScheduler: () => import('@/views/Agenda/AgendaScheduler'),
    DeudasCliente: () => import('@/views/Clientes/Components/DeudasCliente'),
    CitasCliente: () => import('@/views/Agenda/components/CitasCliente'),
    VentasCliente: () => import('@/views/Ventas/VentasCliente'),
    VentasClienteOnline: () => import('@/views/Ventas/VentasClienteOnline'),
    TablaBonosVendidos: () => import('@/views/Clientes/Components/TablaBonosVendidos'),
    TablaTarjetasFidelidadVendidas: () => import('@/views/Ventas/components/TablaTarjetasFidelidadVendidas'),
    TablaPresupuestos: () => import('@/views/Clientes/Components/TablaPresupuestos'),
    TablaSuscripcionesContratadas: () => import('@/views/Configuracion/Suscripciones/components/TablaSuscripcionesContratadas'),
    TablaDocumentos: () => import('@/views/Clientes/Components/TablaDocumentos'),
    FormDocumento: () => import ('@/views/Clientes/Components/FormDocumento'),
    TablaEncuestas: () => import('@/views/Marketing/components/TablaEncuestas'),
    Cuestionarios: () => import('@/views/Clientes/Components/Cuestionarios'),
    TabConsentimientos: () => import('@/views/Clientes/Components/TabConsentimientos'),
    FormCita: () => import('@/views/Agenda/components/FormCita'),
    FormSMS: () => import('@/views/Clientes/Components/FormSMS'),
    FormEmail: () => import('@/views/Clientes/Components/FormEmail'),
    FormSMSProgramado: () => import('@/views/Clientes/Components/FormSMSProgramado'),
    FormUnir: () => import('@/views/Clientes/Components/FormUnir'),
    FormVenta: () => import('@/views/Ventas/components/FormVenta'),
    DialogSesiones: () => import('@/views/Clientes/Components/DialogSesiones'),
    FormEditarBonoVendido: () => import('@/views/Clientes/Components/FormEditarBonoVendido'),
    DialogTraspasarSaldoTarjetaFidelidad: () => import('@/views/Clientes/Components/DialogTraspasarSaldoTarjetaFidelidad'),
    DialogMovimientosTarjetaFidelidad: () => import('@/views/Clientes/Components/DialogMovimientosTarjetaFidelidad'),
    FormPresupuesto: () => import('@/views/Clientes/Components/FormPresupuesto'),
    DialogFotoCliente: () => import('@/views/Clientes/Components/DialogFotoCliente'),
  }
}
</script>
